import {CookiePolicyPage as CookiePolicy} from './CookiePolicy';
export default CookiePolicy;
